<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_8205_6171)">
      <path d="M1 13H11" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M1 8H4" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M10 8.00098L15 8.00098" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M7 9.99316L7 6.45264" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M13.9014 5.25L13.9014 1.00138" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M14 15L14 10.7514" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
      <path d="M1 3H11" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
    </g>
    <defs>
      <clipPath id="clip0_8205_6171">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconFilter'
}
</script>
